(function(){

    'use strict';

    // Grab the back button(s), <button> elements only!
    // Anchors will direct to a specific page
    let backButtons = document.querySelectorAll('button.back-button');

    for (let backButton of backButtons) {
        backButton.addEventListener('click', (event) => {
            event.preventDefault();
            history.back(-1);
        });
    }
}());
